import { getLabelValue } from '@sportal365/smp-widget-utils';
import { ILabels, ParticipantType } from '../../../../packages/types/common';
import { EventTypeCode, IMatchEventSnakeCase } from '../../../../packages/types/football';
import { NumberCard } from '../widgets/Timeline/EventInfo';

export const reverseByTeamPosition = (event: IMatchEventSnakeCase) =>
  event.team_position === ParticipantType.AWAY ? 'row' : 'row-reverse';

export const alignByTeamPosition = (event: IMatchEventSnakeCase) => (event.team_position === ParticipantType.AWAY ? 'left' : 'right');

export const positionImageByTeamPosition = (event: IMatchEventSnakeCase): React.CSSProperties =>
  event.team_position === ParticipantType.AWAY ? { marginRight: '8px' } : { marginLeft: '8px' };

export const isGeneralEvent = (typeCode: string) => {
  const generalEvents = [
    EventTypeCode.HALFTIME,
    EventTypeCode.FINISHED_AFTER_EXTRA_TIME,
    EventTypeCode.FINISHED_FIRST_HALF,
    EventTypeCode.FINISHED_AFTER_PENALTIES,
    EventTypeCode.FINISHED,
  ];

  return generalEvents.includes(typeCode as EventTypeCode);
};

export const getGeneralEventLabel = (typeCode: string, dataLabels: ILabels | undefined) => {
  switch (typeCode) {
    case EventTypeCode.HALFTIME:
      return getLabelValue(dataLabels?.half_time, '1st half-time');
    case EventTypeCode.FINISHED_AFTER_EXTRA_TIME:
      return getLabelValue(dataLabels?.finished_after_extra_time, 'finished after extra time');
    case EventTypeCode.FINISHED_AFTER_PENALTIES:
      return getLabelValue(dataLabels?.finished_after_penalties, 'finished after penalties');
    case EventTypeCode.FINISHED_FIRST_HALF:
      return getLabelValue(dataLabels?.first_half_time_finish, '1st half-time');
    case EventTypeCode.FINISHED:
      return getLabelValue(dataLabels?.second_half_time_finish, '2nd half-time');
    default:
      return typeCode;
  }
};

export const shouldShowMinutes = (event: IMatchEventSnakeCase) => {
  const eventsWithoutUIMinutes = [
    EventTypeCode.KICKOFF,
    EventTypeCode.HALFTIME,
    EventTypeCode.START_SECOND_HALF,
    EventTypeCode.FINISHED_FIRST_HALF,
    EventTypeCode.FINISHED_AFTER_EXTRA_TIME,
    EventTypeCode.FINISHED_AFTER_PENALTIES,
    EventTypeCode.OVERTIME_FIRST_HALF,
    EventTypeCode.OVERTIME_FIRST_HALF_END,
    EventTypeCode.OVERTIME_SECOND_HALF,
    EventTypeCode.INJURY_TIME,
    EventTypeCode.FINISHED,
  ];

  return !eventsWithoutUIMinutes.includes(event.type_code);
};

export const showMinutes = (event: IMatchEventSnakeCase) => {
  if (event.injury_minute && event.minute) {
    return `${event.minute}+${event.injury_minute}'`;
  }

  if (event.minute) {
    return `${event.minute}'`;
  }

  return '';
};

export const isEventForSkip = (typeCode: string) => {
  const eventsForSkip = [
    EventTypeCode.START_SECOND_HALF,
    EventTypeCode.FINISHED_FIRST_HALF,
    EventTypeCode.OVERTIME_FIRST_HALF,
    EventTypeCode.OVERTIME_FIRST_HALF_END,
    EventTypeCode.OVERTIME_SECOND_HALF,
  ];

  return eventsForSkip.includes(typeCode as EventTypeCode);
};

export const getNumberCard = (allEvents: IMatchEventSnakeCase[], currentEventIndex: number) => {
  const eventsTillTheCurrentEvent = allEvents.slice(0, currentEventIndex + 1);
  const playerIdOfCurrentEvent = allEvents[currentEventIndex]?.primary_player?.id;
  const typeOfCurrentEvent = allEvents[currentEventIndex].type_code;

  if (typeOfCurrentEvent === EventTypeCode.GOAL) {
    const samePlayerGoalsEvents = eventsTillTheCurrentEvent.filter(
      ({ type_code, primary_player }) => type_code === EventTypeCode.GOAL && primary_player?.id === playerIdOfCurrentEvent,
    );
    return samePlayerGoalsEvents.length > 1 ? <NumberCard>{samePlayerGoalsEvents.length}</NumberCard> : null;
  } else if (typeOfCurrentEvent === EventTypeCode.OWN_GOAL) {
    const samePlayerOwnGoalsEvents = eventsTillTheCurrentEvent.filter(
      ({ type_code, primary_player }) => type_code === EventTypeCode.OWN_GOAL && primary_player?.id === playerIdOfCurrentEvent,
    );

    return samePlayerOwnGoalsEvents.length > 1 ? <NumberCard>{samePlayerOwnGoalsEvents.length}</NumberCard> : null;
  }

  return null;
};
